import { PlatformGroupRoleDto } from "./PlatformGroupRoleDto";
import { TenantDto } from "./TenantDto";

export class User {
    id!: string;
    userName!: string;
    email!: string;
    emailConfirmed!: boolean;
    phoneNumber!: string;
    phoneNumberConfirmed!: boolean;
    lockoutEnabled!: boolean;
    twoFactorEnabled!: boolean;
    accessFailedCount!: number;
    lockoutEnd!: Date;   
}

export class UsersDto {
    pageSize!: number;
    totalCount!: number;
    users!: UserDto[];
}

export class UserDto {
    id!: string;
    firstName!:string;
    lastName!:string;
    userName!: string;
    email!: string;
    emailConfirmed!: boolean;
    phoneNumber!: string;
    phoneNumberConfirmed!: boolean;
    lockoutEnabled!: boolean;
    twoFactorEnabled!: boolean;
    accessFailedCount!: number;
    lockoutEnd?:Date;
    userRoles!:PlatformGroupRoleDto[];
    isDemoUser!: boolean;
    tenant!:TenantDto[];
}

export class DemoUserDto {
    id!: string;
    userName!: string;
    companyName!: string;
    email!: string;
    phoneNumber!: string;
    buildingconstruction!: boolean;
    infrastructure!: boolean;
}

export class UserResolved {
    userDto!: UserDto;
    error?:any;    
}

export class LoginInputModel
{
    email!: string;
    password!: string;
}


